import React, { useState, useEffect } from "react";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Grid,
  Tooltip,
} from "@mui/material";
import { NotificationManager } from "react-notifications";

export default function CommonSearchCriteria({
  orderStatusOptions,
  onSearch,
  extraActions,
  searchTooltip = "Search across multiple fields in the records",
  dateRangeTooltip = "Select date range on which any action was performed",
}) {
  const [searchText, setSearchText] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const today = new Date();

    const startDateValue = new Date(today);
    startDateValue.setDate(today.getDate() - 15);
    setStartDate(startDateValue.toISOString().split("T")[0]);

    const endDateValue = new Date(today);
    endDateValue.setDate(today.getDate() + 15);
    setEndDate(endDateValue.toISOString().split("T")[0]);
  }, []);

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (startDate === "" || endDate === "") {
      NotificationManager.error("Invalid Dates");
      return;
    }

    onSearch({ searchText, orderStatus, startDate, endDate });
  };

  return (
    <form onSubmit={handleSearchSubmit}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={extraActions ? 2 : 3}>
          <Tooltip title={searchTooltip} arrow placement="top">
            <TextField
              label="Search Criteria"
              variant="outlined"
              fullWidth
              size="small"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={extraActions ? 2 : 3}>
          <FormControl variant="outlined" fullWidth size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={orderStatus}
              onChange={(e) => setOrderStatus(e.target.value)}
              label="Status"
            >
              <MenuItem value="">
                <em>Select Any Status</em>
              </MenuItem>
              {orderStatusOptions.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={2}>
          <Tooltip title={dateRangeTooltip} arrow placement="top">
            <TextField
              label="From Date"
              type="date"
              variant="outlined"
              fullWidth
              size="small"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={2}>
          <Tooltip title={dateRangeTooltip} arrow placement="top">
            <TextField
              label="To Date"
              type="date"
              variant="outlined"
              fullWidth
              size="small"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="medium"
            style={{ height: "40px" }}
            fullWidth
          >
            Search
          </Button>
        </Grid>

        {extraActions && (
          <Grid item xs={12} sm={2}>
            {extraActions}
          </Grid>
        )}
      </Grid>
    </form>
  );
}